import Reflux from 'reflux';

const InputsActions = Reflux.createActions({
  'list': {asyncResult: true},
  'get': {asyncResult: true},
  'create': {asyncResult: true},
  'delete': {asyncResult: true},
  'update': {asyncResult: true},
});

export default InputsActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/inputs/InputsActions.js